define('boxes/deposit-bonus/deposit-bonus-box',['jquery', 'boxes/box', 'boxes/deposit-bonus/deposit-bonus-model', 'boxes/deposit-bonus/deposit-bonus-view'], function($, box, depositBonusModel, depositBonusView) {
    'use strict';

    return {
        create: function ($box, $controller) {
            return box.create($box, $controller, depositBonusView, depositBonusModel);
        }
    };
});

